import { render, staticRenderFns } from "./edit-user-form.vue?vue&type=template&id=90d1b8e0&scoped=true&"
import script from "./edit-user-form.vue?vue&type=script&lang=js&"
export * from "./edit-user-form.vue?vue&type=script&lang=js&"
import style0 from "./edit-user-form.vue?vue&type=style&index=0&id=90d1b8e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d1b8e0",
  null
  
)

export default component.exports